"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var Snippets = require("snippets");
var Sections = require("sections");
var reactive_click_and_collect_1 = require("@dotdev/reactive-click-and-collect");
var click_and_collect_1 = require("../snippet/click-and-collect");
var CartTemplate = /** @class */ (function (_super) {
    __extends(CartTemplate, _super);
    function CartTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCCModal = function () {
            _this.setState({
                ccModal: !_this.state.ccModal
            });
        };
        _this.clickAndCollect = new reactive_click_and_collect_1.ClickAndCollect({
            endpoint: {
                locations: "" + (_this.props.data.shop.permanent_domain == "the-afl-store-au-stage.myshopify.com"
                    ? "https://connector-staging.theaflstore.io/api/locations"
                    : "https://connector.theaflstore.io/api/locations"),
                stock: "" + (_this.props.data.shop.permanent_domain == "the-afl-store-au-stage.myshopify.com"
                    ? "https://connector-staging.theaflstore.io/api/stock"
                    : "https://connector.theaflstore.io/api/stock")
            },
            googleMapsApiVersion: "3.37",
            googleMapsApiKey: "AIzaSyC2pbhg5eMUosOwcUVcn0RWuYaqbdGMXmc"
        });
        _this.buildPlaceholders = function (limit) {
            var placeholders = [];
            for (var i = 0; i < limit; i++) {
                placeholders.push(React.createElement("div", { key: i, className: "flex flex-no-wrap py-1-5 md:py-2-3 border-b border-secondary" },
                    React.createElement("div", { className: "w-1/4" },
                        React.createElement("div", { className: "ratio-2:3 content-placeholder" })),
                    React.createElement("div", { className: "w-3/4 flex flex-col justify-between pl-2" },
                        React.createElement("div", { className: "flex items-start justify-between" },
                            React.createElement("div", { className: "w-3/4 pr-1" },
                                React.createElement("p", { className: "content-placeholder medium py-1" }),
                                React.createElement("p", { className: "content-placeholder large py-0-7 mt-1" })),
                            React.createElement("div", { className: "w-1/4 text-right" },
                                React.createElement("div", { className: "content-placeholder w-5 h-5 inline-block" }))),
                        React.createElement("div", { className: "flex items-center justify-between mt-2-5" },
                            React.createElement("div", { className: "w-1/2" },
                                React.createElement("div", { className: "content-placeholder large py-1-5" })),
                            React.createElement("div", { className: "w-1/2 pl-2 text-right" },
                                React.createElement("div", { className: "content-placeholder inline-block small py-1-5" }))))));
            }
            return placeholders;
        };
        _this.state = {
            ccSelected: false,
            ccModal: false,
            ccLocationId: _this.getCCLocationId(_this.props.data.cart),
            ccLocationName: _this.getCCLocationName(_this.props.data.cart),
            availableAtLocation: [],
            cncEnabled: _this.props.data.settings.click_and_collect_enabled
        };
        _this.toggleCCModal = _this.toggleCCModal.bind(_this);
        _this.updateCart = _this.updateCart.bind(_this);
        return _this;
    }
    CartTemplate.prototype.componentDidMount = function () {
        this.setState({
            ccSelected: !!this.state.ccLocationId
        });
        if (this.state.ccLocationId) {
            this.checkStock(this.state.ccLocationId).then(function (response) { });
        }
    };
    CartTemplate.prototype.componentDidUpdate = function () {
        !(this.context.state.recommendations && this.context.state.recommendations.length) &&
            this.context.state.cart &&
            this.context.state.cart.items &&
            this.context.state.cart.items[0]
            ? next_components_1.ShopifyNext.Cart.getProductRecommendations(this.context.state.cart.items[0].product_id, 12)
            : null;
    };
    CartTemplate.prototype.render = function () {
        var _this = this;
        var cart = this.context.state.cart;
        var locales = this.props.data.locales;
        var allInStock = Object.values(this.state.availableAtLocation).filter(function (inventory) { return Number.parseInt(inventory) > 0; }).length ==
            (cart && cart.items ? cart.items.length : 0);
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("div", { className: "relative bg-very-light-pink " },
                React.createElement("div", { className: "hidden " + (cart && cart.item_count == 0 ? "hidden" : "md:block") + "  bg-arctic absolute pin-l h-full w-gold" }),
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "md:px-11 flex-col md:flex-row items-center md:bg-transparent relative" },
                    React.createElement("div", { className: "w-full flex flex-row bg-very-light-pink" },
                        React.createElement("div", { className: "hidden md:block md:w-gold z-10 bg-arctic " + (cart && cart.item_count == 0 ? "md:bg-very-light-pink" : "md:bg-arctic") + " pt-1-3 pb-3-7" },
                            React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                        React.createElement("div", { className: "md:w-gold-reverse z-10 " }))),
                React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "md:px-11" }, cart && cart.item_count > 0 ? (React.createElement("div", { className: "flex flex-wrap md:flex-no-wrap" },
                    React.createElement("div", { className: "w-full md:w-gold px-1-6 md:px-0 md:pr-2-4 pb-2-7 z-10 bg-arctic md:bg-transparant pt-3-3 md:pt-0" },
                        React.createElement("div", { className: "mb-2-7" }, cart && cart.item_count > 0 ? (React.createElement(Snippets.Heading, { size: "h1", tag: "h1", className: "text-navy-dark text-xmd font-semibold" },
                            locales.cart.general.title,
                            "\u00A0",
                            cart && cart.item_count > 0 ? "(" + cart.item_count + " Items)" : null)) : null),
                        React.createElement("div", { className: "hidden md:block md:mb-3 text-xs uppercase  font-semibold" },
                            cart.items && cart.items.length ? (React.createElement("div", { className: "border-b border-grey-light py-0-6 flex flex-row  w-full" },
                                React.createElement("p", { className: "w-5/8" }, "Product Name"),
                                React.createElement("p", { className: "w-1/8" }, "Size"),
                                React.createElement("p", { className: "w-1/8 text-center" }, "QTY"),
                                React.createElement("p", { className: "w-1/8 text-right" }, "Price"))) : null,
                            cart.items && cart.items.length
                                ? cart.items.map(function (lineitem, i) { return (React.createElement(Snippets.CartItem, __assign({}, _this.props, { lineitem: lineitem, key: lineitem.key, quantity: lineitem.quantity, stockInStore: _this.state.availableAtLocation[lineitem.sku], cncSelected: _this.state.cncEnabled && _this.state.ccSelected, cncAvailable: _this.state.availableAtLocation["" + lineitem.sku] >= lineitem.quantity, cncStore: _this.state.ccLocationName }))); })
                                : this.buildPlaceholders(cart.item_count)),
                        React.createElement("div", { className: "block md:hidden mb-2-4" }, cart.items && cart.items.length
                            ? cart.items.map(function (lineitem, i) { return (React.createElement(Snippets.CartItem, __assign({}, _this.props, { lineitem: lineitem, key: lineitem.key, drawer: true, quantity: lineitem.quantity }))); })
                            : this.buildPlaceholders(cart.item_count)),
                        React.createElement("div", { className: "block md:mb-3-4" },
                            React.createElement("a", { className: "w-full flex items-center justify-start text-charcoal  hover:text-midnight transition-fast", href: "/collections", title: locales.cart.general.continue },
                                React.createElement(Snippets.Svg, { name: "chevron-left", className: "block", height: 14 }),
                                React.createElement("p", { className: "ml-0-7 text-base uppercase font-bold text-navy-dark" }, locales.cart.general.continue)))),
                    React.createElement("div", { className: "w-full md:w-gold-reverse pb-2-7 px-1-6 pt-2-6 md:pt-0 bg-very-light-pink z-10" },
                        React.createElement("div", { className: "pb-1-7 md:pl-3-2 " },
                            React.createElement(Snippets.Heading, { size: "h1", tag: "h4", className: "mb-1-9 text-xmd font-semibold capitalize" }, locales.cart.summary.title),
                            React.createElement("div", { className: "flex flex-col pb-1-6 border-b border-blue-grey mb-2" },
                                React.createElement("div", { className: "text-navy-dark text-base font-semibold mb-0-4" }, "Have a coupon code?"),
                                React.createElement("div", { className: "text-grey-dark text-xs" }, "Add your coupon code in the next step.")),
                            this.state.cncEnabled ? (React.createElement("div", { className: "flex flex-col pb-1-6 border-blue-grey mb-2" },
                                React.createElement("div", { className: "text-navy-dark text-base font-semibold mb-0-4" }, "Select Delivery Type"),
                                React.createElement("div", { className: "text-grey-dark text-xs" }, "Choose your preferred delivery method for your shopping cart and then proceed to checkout."),
                                React.createElement("div", { className: "bg-arctic shadow mt-2 rounded" },
                                    React.createElement("div", { className: "border-b border-blue-grey p-1-6" },
                                        React.createElement("div", { className: "flex cursor-pointer", onClick: function (event) { return _this.ccRemove(); } },
                                            React.createElement("div", { className: "mr-1-6" },
                                                React.createElement(Snippets.Svg, { name: this.state.ccSelected ? "radio-inactive" : "radio-active", width: 18 })),
                                            React.createElement("div", { className: "" },
                                                React.createElement("div", { className: "text-navy-dark text-base font-semibold mb-0-4" }, "Home Delivery"),
                                                this.props.data.section.cart.settings.shipping && cart.items && cart.items.length >= 0 ? (React.createElement("div", { className: "" }, cart.total_price > this.props.data.section.cart.settings.shipping * 100 ? (React.createElement("p", { className: "text-grey-dark text-xs" },
                                                    "Free shipping for orders over",
                                                    " ",
                                                    next_components_1.ShopifyNext.Utils.formatMoney(this.props.data.section.cart.settings.shipping * 100, this.props.data.shop.money_format))) : (React.createElement("p", { className: "text-grey-dark text-xs" },
                                                    "Spend",
                                                    " ",
                                                    next_components_1.ShopifyNext.Utils.formatMoney(this.props.data.section.cart.settings.shipping * 100 - cart.total_price, this.props.data.shop.money_format),
                                                    " ",
                                                    "more to be eligible for free shipping!")))) : null))),
                                    React.createElement("div", { className: "w-full p-1-6 flex justify-between" },
                                        React.createElement("div", { className: "flex cursor-pointer", onClick: function () { return _this.toggleCCModal(); } },
                                            React.createElement("div", { className: "mr-1-6" },
                                                React.createElement(Snippets.Svg, { name: this.state.ccSelected ? "radio-active" : "radio-inactive", width: 18 })),
                                            React.createElement("div", { className: "" },
                                                React.createElement("div", { className: "text-navy-dark text-base font-semibold mb-0-4" }, "Collect from store"),
                                                React.createElement("div", { className: "text-grey-dark text-xs" }, this.state.ccSelected ? this.state.ccLocationName : ""))),
                                        React.createElement("div", { className: "text-navy-dark text-base font-semibold underline cursor-pointer", onClick: function () { return _this.toggleCCModal(); } }, "Change store"))),
                                !allInStock && this.state.ccSelected ? (React.createElement("div", { className: "w-full py-1-6" },
                                    React.createElement("p", { className: "text-red font-sans text-base text-left" },
                                        "Some Products are unavailable at ",
                                        this.state.ccLocationName,
                                        ". Please select a different store or remove these items from your bag to continue."))) : null)) : null,
                            React.createElement("div", { className: "flex items-center text-grey-dark justify-between mb-1-4" },
                                React.createElement("p", { className: "text-xs" }, locales.cart.summary.delivery),
                                React.createElement("p", { className: "text-xs" }, "Calculated at Checkout")),
                            cart && cart.total_price !== null ? (React.createElement("div", { className: "flex w-full items-end justify-between mb-2-4" },
                                React.createElement("p", { className: "text-base font-semibold uppercase" }, locales.cart.label.total),
                                React.createElement("div", { className: "flex flex-row items-end" },
                                    React.createElement("p", { className: "text-base text-grey-dark" },
                                        this.props.data.shop.currency,
                                        "\u00A0"),
                                    React.createElement("p", { className: "text-36 font-bold leading-none" }, next_components_1.ShopifyNext.Utils.formatMoney(cart.total_price, this.props.data.shop.money_format))))) : null,
                            allInStock || !this.state.ccSelected ? (React.createElement(Snippets.Button, { style: "tertiary", className: "w-full rounded mb-1-6", href: "checkout" }, locales.cart.general.checkout)) : (React.createElement(Snippets.Button, { style: "tertiary", disabled: true, className: "w-full rounded mb-1-6", href: "" }, locales.cart.general.checkout)),
                            React.createElement("div", { className: "w-full flex justify-center" },
                                React.createElement(Snippets.PaymentIcons, __assign({}, this.props, { iconHeight: 16 }))),
                            this.props.data.cart.checkout_buttons && !this.props.data.customer ? (React.createElement("div", { className: "w-full flex flex-col items-center justify-center mt-2-4" },
                                React.createElement("div", { className: "mb-2-4 text-xs text-grey-dark" }, "-\u00A0Or\u00A0-"),
                                React.createElement("div", { className: "" + (!this.context.state.cart.items ? " pointer-events-none opacity-50" : "") }, next_components_1.ShopifyNext.Utils.parseHTML(this.props.data.cart.checkout_buttons)))) : null)))) : (React.createElement("div", { className: "py-7-2 md:py-12 text-center text-navy-dark z-10" },
                    React.createElement(Snippets.Heading, { size: "h3", tag: "h1" }, locales.cart.general.empty.title),
                    React.createElement(Snippets.Button, { className: "mt-2-2", style: "tertiary", href: "/collections", title: locales.cart.general.continue }, locales.cart.general.continue))))),
            cart && cart.item_count > 0 ? (React.createElement("section", { className: "bg-fleece pt-4-8" },
                React.createElement(Snippets.Container, { width: "xl", className: "px-1-6 md:px-11" },
                    React.createElement(Snippets.ProductRecommended, __assign({}, this.props, { title: "Customers who bought these items also purchased", className: "mt-13", section: this.props.data.section.prods, limit: 6, simple: true, quickAdd: true }))))) : null,
            React.createElement(Sections.CTA, __assign({}, this.props, { section: this.props.data.section.cta })),
            this.state.ccModal ? (React.createElement(click_and_collect_1.ClickCollect, __assign({ variants: cart.items }, this.props, { show: this.state.ccModal, toggle: this.toggleCCModal, update: true, updateCart: this.updateCart }))) : null));
    };
    CartTemplate.prototype.getCCLocationId = function (cart) {
        var location = null;
        cart.attributes._click_and_collect == "true" &&
            cart.items.forEach(function (item) {
                if (item.properties._click_and_collect == "true") {
                    location = cart.attributes.pickup_store_id ? cart.attributes.pickup_store_id : null;
                }
            });
        return location;
    };
    CartTemplate.prototype.getCCLocationName = function (cart) {
        var location = null;
        cart.attributes._click_and_collect == "true" &&
            cart.items.forEach(function (item) {
                if (item.properties._click_and_collect == "true") {
                    location = cart.attributes.pickup_store_name ? cart.attributes.pickup_store_name : null;
                }
            });
        return location;
    };
    CartTemplate.prototype.ccRemove = function () {
        reactive_click_and_collect_1.ClickAndCollect.Cart.LocationRemove();
        this.setState({
            ccSelected: false,
            ccModal: false,
            ccLocationId: null,
            ccLocationName: null
        });
    };
    CartTemplate.prototype.checkStock = function (store_id) {
        return __awaiter(this, void 0, void 0, function () {
            var availability;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.clickAndCollect.checkStock(store_id)];
                    case 1:
                        availability = _a.sent();
                        this.setState({
                            availableAtLocation: availability.items
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CartTemplate.prototype.updateCart = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    ccSelected: true,
                    ccModal: false,
                    ccLocationName: location.name,
                    ccLocationId: location.store_id
                });
                this.checkStock(location.store_id);
                return [2 /*return*/];
            });
        });
    };
    CartTemplate.contextType = next_components_1.ShopifyNext.Context;
    return CartTemplate;
}(React.Component));
exports.CartTemplate = CartTemplate;
